<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/tuning/tuning.jpg" alt="软件算法">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">调 音</div>
                <div class="detail-banner-desc">
                    专业调音团队；<br />
                    因车制宜，专车专调，最大化优化座舱聆听体验；<br />
                    数据分析能力，主客观目标清晰；<br />
                    具有：声像定位准确 & 声场开阔、频响准确 & 细节丰富、各位置听感均衡等特点。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">调音技术</div>
                    <div class="detail-desc">
                        <div>
                            独有 Amor Aural® 车内声场重构技术，基于车内声学传递函数进行计算分析、精准控制各扬声器间的协同，降低系统失真、实现车内声学性能的主、客观的统一，及各乘客位效果的均衡。
                        </div>
                        <div>
                            独有发动机主动降噪与路噪降噪标定方案，基于车内噪声传递路径分析与实时工况响应，精细调校主动控制策略的增益与相位，实现发动机阶次噪声与路面激励噪声的有效衰减，确保全速域、全路况下静谧性的一致与主观舒适度的提升。
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/tuning/tyjs.jpg" alt="调音技术">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                团队优势
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">资深声学调音团队，曾服务于世界知名音响品牌，并具备十年以上声学领域的研究与实战经验</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">调音室</div>
                    <div class="detail-desc">
                        <div>
                            搭建专业的调音实验室和标准听音室，满足听音对标、算法验证、实车调音等各类需求，具备从基础调音到复杂声学环境的调音能力（audio&降噪）。
                        </div>
                    </div>
                </div>

                <div class="spec-row">

                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                团队优势
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">资深声学调音团队，曾服务于世界知名音响品牌，并具备十年以上声学领域的研究与实战经验</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/tuning/tys.jpg" alt="调音室">
                    </div>
                </div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '调 音 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/tuning.html'
};

import { createApp } from 'vue';
import App from './tuning.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./tuning.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
